import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

export default props => (
	<SvgIcon {...props} viewBox="0 0 32 36">
		<path d="M17.175 4.867c1.205-1.29 2.02-3.081 1.797-4.867-1.736.062-3.84 1.019-5.086 2.309-1.117 1.142-2.095 2.967-1.834 4.718 1.937.131 3.916-.872 5.123-2.16zm3.697 12.334c-.037-4.004 3.17-5.927 3.312-6.02-1.803-2.719-4.611-3.091-5.611-3.133-2.391-.251-4.662 1.448-5.876 1.448-1.209 0-3.079-1.415-5.062-1.377-2.607.043-5.009 1.561-6.348 3.967-2.708 4.84-.694 12.01 1.945 15.936 1.29 1.922 2.826 4.078 4.843 4 1.947-.078 2.681-1.295 5.03-1.295 2.35 0 3.008 1.295 5.064 1.256 2.092-.039 3.416-1.959 4.695-3.887 1.48-2.229 2.09-4.387 2.125-4.496-.045-.026-4.074-1.611-4.117-6.399z"/>
	</SvgIcon>
);




// WEBPACK FOOTER //
// ./src/client/components/admin/analytics/icons/apple.jsx